/**
 * @fileoverview gRPC-Web generated client stub for acompanha.app_notifications.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/app_notifications/v1/app_notifications.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.app_notifications = {};
proto.acompanha.app_notifications.v1 = require('./app_notifications_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.app_notifications.v1.AppNotificationsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.app_notifications.v1.AppNotificationsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.app_notifications.v1.ListAppNotificationsRequest,
 *   !proto.acompanha.app_notifications.v1.ListAppNotificationsResponse>}
 */
const methodDescriptor_AppNotificationsService_ListAppNotifications = new grpc.web.MethodDescriptor(
  '/acompanha.app_notifications.v1.AppNotificationsService/ListAppNotifications',
  grpc.web.MethodType.UNARY,
  proto.acompanha.app_notifications.v1.ListAppNotificationsRequest,
  proto.acompanha.app_notifications.v1.ListAppNotificationsResponse,
  /**
   * @param {!proto.acompanha.app_notifications.v1.ListAppNotificationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.app_notifications.v1.ListAppNotificationsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.app_notifications.v1.ListAppNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.app_notifications.v1.ListAppNotificationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.app_notifications.v1.ListAppNotificationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.app_notifications.v1.AppNotificationsServiceClient.prototype.listAppNotifications =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/ListAppNotifications',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_ListAppNotifications,
      callback);
};


/**
 * @param {!proto.acompanha.app_notifications.v1.ListAppNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.app_notifications.v1.ListAppNotificationsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.app_notifications.v1.AppNotificationsServicePromiseClient.prototype.listAppNotifications =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/ListAppNotifications',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_ListAppNotifications);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest,
 *   !proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse>}
 */
const methodDescriptor_AppNotificationsService_ListSentAppNotifications = new grpc.web.MethodDescriptor(
  '/acompanha.app_notifications.v1.AppNotificationsService/ListSentAppNotifications',
  grpc.web.MethodType.UNARY,
  proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest,
  proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse,
  /**
   * @param {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.app_notifications.v1.AppNotificationsServiceClient.prototype.listSentAppNotifications =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/ListSentAppNotifications',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_ListSentAppNotifications,
      callback);
};


/**
 * @param {!proto.acompanha.app_notifications.v1.ListSentAppNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.app_notifications.v1.ListSentAppNotificationsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.app_notifications.v1.AppNotificationsServicePromiseClient.prototype.listSentAppNotifications =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/ListSentAppNotifications',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_ListSentAppNotifications);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.app_notifications.v1.GetUnreadCountRequest,
 *   !proto.acompanha.app_notifications.v1.GetUnreadCountResponse>}
 */
const methodDescriptor_AppNotificationsService_GetUnreadCount = new grpc.web.MethodDescriptor(
  '/acompanha.app_notifications.v1.AppNotificationsService/GetUnreadCount',
  grpc.web.MethodType.UNARY,
  proto.acompanha.app_notifications.v1.GetUnreadCountRequest,
  proto.acompanha.app_notifications.v1.GetUnreadCountResponse,
  /**
   * @param {!proto.acompanha.app_notifications.v1.GetUnreadCountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.app_notifications.v1.GetUnreadCountResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.app_notifications.v1.GetUnreadCountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.app_notifications.v1.GetUnreadCountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.app_notifications.v1.GetUnreadCountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.app_notifications.v1.AppNotificationsServiceClient.prototype.getUnreadCount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/GetUnreadCount',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_GetUnreadCount,
      callback);
};


/**
 * @param {!proto.acompanha.app_notifications.v1.GetUnreadCountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.app_notifications.v1.GetUnreadCountResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.app_notifications.v1.AppNotificationsServicePromiseClient.prototype.getUnreadCount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/GetUnreadCount',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_GetUnreadCount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.app_notifications.v1.CreateAppNotificationRequest,
 *   !proto.acompanha.app_notifications.v1.CreateAppNotificationResponse>}
 */
const methodDescriptor_AppNotificationsService_CreateAppNotification = new grpc.web.MethodDescriptor(
  '/acompanha.app_notifications.v1.AppNotificationsService/CreateAppNotification',
  grpc.web.MethodType.UNARY,
  proto.acompanha.app_notifications.v1.CreateAppNotificationRequest,
  proto.acompanha.app_notifications.v1.CreateAppNotificationResponse,
  /**
   * @param {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.app_notifications.v1.CreateAppNotificationResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.app_notifications.v1.CreateAppNotificationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.app_notifications.v1.CreateAppNotificationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.app_notifications.v1.AppNotificationsServiceClient.prototype.createAppNotification =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/CreateAppNotification',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_CreateAppNotification,
      callback);
};


/**
 * @param {!proto.acompanha.app_notifications.v1.CreateAppNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.app_notifications.v1.CreateAppNotificationResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.app_notifications.v1.AppNotificationsServicePromiseClient.prototype.createAppNotification =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/CreateAppNotification',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_CreateAppNotification);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest,
 *   !proto.acompanha.common.v1.SuccessResponse>}
 */
const methodDescriptor_AppNotificationsService_MarkAppNotificationRead = new grpc.web.MethodDescriptor(
  '/acompanha.app_notifications.v1.AppNotificationsService/MarkAppNotificationRead',
  grpc.web.MethodType.UNARY,
  proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest,
  acompanha_common_v1_common_pb.SuccessResponse,
  /**
   * @param {!proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.SuccessResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.SuccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.SuccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.app_notifications.v1.AppNotificationsServiceClient.prototype.markAppNotificationRead =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/MarkAppNotificationRead',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_MarkAppNotificationRead,
      callback);
};


/**
 * @param {!proto.acompanha.app_notifications.v1.MarkAppNotificationReadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.SuccessResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.app_notifications.v1.AppNotificationsServicePromiseClient.prototype.markAppNotificationRead =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/MarkAppNotificationRead',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_MarkAppNotificationRead);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest,
 *   !proto.acompanha.common.v1.SuccessResponse>}
 */
const methodDescriptor_AppNotificationsService_MarkAllAppNotificationsRead = new grpc.web.MethodDescriptor(
  '/acompanha.app_notifications.v1.AppNotificationsService/MarkAllAppNotificationsRead',
  grpc.web.MethodType.UNARY,
  proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest,
  acompanha_common_v1_common_pb.SuccessResponse,
  /**
   * @param {!proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.SuccessResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.SuccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.SuccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.app_notifications.v1.AppNotificationsServiceClient.prototype.markAllAppNotificationsRead =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/MarkAllAppNotificationsRead',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_MarkAllAppNotificationsRead,
      callback);
};


/**
 * @param {!proto.acompanha.app_notifications.v1.MarkAllAppNotificationsReadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.SuccessResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.app_notifications.v1.AppNotificationsServicePromiseClient.prototype.markAllAppNotificationsRead =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/MarkAllAppNotificationsRead',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_MarkAllAppNotificationsRead);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest,
 *   !proto.acompanha.common.v1.SuccessResponse>}
 */
const methodDescriptor_AppNotificationsService_DeleteAllAppNotifications = new grpc.web.MethodDescriptor(
  '/acompanha.app_notifications.v1.AppNotificationsService/DeleteAllAppNotifications',
  grpc.web.MethodType.UNARY,
  proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest,
  acompanha_common_v1_common_pb.SuccessResponse,
  /**
   * @param {!proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.SuccessResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.SuccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.SuccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.app_notifications.v1.AppNotificationsServiceClient.prototype.deleteAllAppNotifications =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/DeleteAllAppNotifications',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_DeleteAllAppNotifications,
      callback);
};


/**
 * @param {!proto.acompanha.app_notifications.v1.DeleteAllAppNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.SuccessResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.app_notifications.v1.AppNotificationsServicePromiseClient.prototype.deleteAllAppNotifications =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/DeleteAllAppNotifications',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_DeleteAllAppNotifications);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_AppNotificationsService_DeleteAppNotification = new grpc.web.MethodDescriptor(
  '/acompanha.app_notifications.v1.AppNotificationsService/DeleteAppNotification',
  grpc.web.MethodType.UNARY,
  proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.app_notifications.v1.AppNotificationsServiceClient.prototype.deleteAppNotification =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/DeleteAppNotification',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_DeleteAppNotification,
      callback);
};


/**
 * @param {!proto.acompanha.app_notifications.v1.DeleteAppNotificationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.app_notifications.v1.AppNotificationsServicePromiseClient.prototype.deleteAppNotification =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.app_notifications.v1.AppNotificationsService/DeleteAppNotification',
      request,
      metadata || {},
      methodDescriptor_AppNotificationsService_DeleteAppNotification);
};


module.exports = proto.acompanha.app_notifications.v1;

